import {
  Academic as AcademicIcon,
  Basics as BasicsIcon,
  Research as ResearchIcon,
  Parallel,
  Upload,
  Edit,
} from "./../../Components/Icon";

import ProposalOverview from "./../../Pages/GeneralInformation/ProposalOverview";
import Basics from "./../../Pages/GeneralInformation/Basics";
import ParallelFunding from "./../../Pages/GeneralInformation/ParallelFunding";
import Research from "./../../Pages/GeneralInformation/Research";
import Academic from "./../../Pages/GeneralInformation/Academic";
import PreviousEmployment from "./../../Pages/GeneralInformation/PreviousEmployment";
import UploadDocs from "./../../Pages/GeneralInformation/UploadDocs";
import { navigationMapBuilder } from "./helpers";
import ApplicantDocs from "../../Pages/GeneralInformation/ApplicantDocs";

const navigation = () => ([
  {
    header: "Applicant Details",
    links: [
      {
        text: "Proposal Overview",
        icon: Edit,
        route: "overview",
        component: ProposalOverview,
        stage:"preProposal"
      },
      { text: "Basics", icon: BasicsIcon, route: "basics", component: Basics, stage:"preProposal" },
      {
        text: "Research Interest",
        icon: ResearchIcon,
        route: "research",
        component: Research,
      },
      {
        text: "Academic Background",
        icon: AcademicIcon,
        route: "academic",
        component: Academic,
      },
      {
        text: "Previous Employment",
        icon: ResearchIcon,
        route: "prevemp",
        component: PreviousEmployment,
      },
      {
        text: "Parallel funding",
        icon: Parallel,
        route: "funding",
        component: ParallelFunding,
      },
      {
        text: "Upload Docs",
        icon: Upload,
        route: "upload",
        component: UploadDocs,
        stage:"preProposal",
      },
      {
        text: "Applicant Docs",
        icon: Upload,
        route: "applicantdocs",
        component: ApplicantDocs,
        stage:"preProposal"
      },
    ],
  },
]);

const navigationMap = (parentRoute) =>
  navigationMapBuilder(parentRoute, navigation);

export default navigationMap;
